export default (context) => {
  const M = "admSuperSection."
  return {
    config: {
      pageSize: 40,
      list: false,
      remapRow: (form) => {
        form.owner = form.owner.label
        return form
      }
    },

    actions: {
      create: { reloadGrid: true },
      edit: { reloadGrid: true },
      delete: false,
      print: false,
      export: false,
      search: true
    },

    extras: {
      items: [],
      itemsInRowsTable: [
        {
          icon: 'simple-icon-note',
          name: `${M}promoteStudents`,
          onClick: (rowData, ctx) => {
            context.state.formFlags = { fromSuperSectionId: rowData.ID, fromSuperSectionName: rowData.name }
          },
          form: {
            name: `${M}promoteStudents`,
            remapGET: () => {
              return { fromSuperSectionId: context.state.formFlags.fromSuperSectionId, fromSuperSectionName: context.state.formFlags.fromSuperSectionName  }
            },
            postUrlF: (ctx) => {
              return 'admSuperSection/promote';
            },
            okMsg: 'Se han promovido los estudiantes!',
            fields: [
              {
                name: "fromSuperSectionId",
                value: 0,
                type: "hidden"
              },
              {
                col: 12,
                name: "fromSuperSectionName",
                value: null,
                type: "text",
                label: `${M}promoteFromGrade`,
                disabled: true,
                opts: {
                  style: 'float-label'
                }
              },
              {
                col: 12,
                name: "otherPromote",
                value: false,
                type: "switch",
                label: `${M}promoteToAnotherState`,
                opts: {
                  style: 'float-label'
                }
              },
              {
                name: "otherPromoteStatus",
                rules: "required",
                value: "",
                col: 12,
                type: "select",
                label: "main.type",
                opts: {
                  style: 'float-label',
                  items: [
                    { value: "0", label: "Nuevo" },
                    { value: "10", label: "Estudiante" },
                    { value: "11", label: "Ingresante" },
                    { value: "12", label: "Re-ingresante" },
                    { value: "20", label: "Graduado" },
                    { value: "21", label: "Retirado durante año" },
                    { value: "22", label: "Fallecido" },
                    { value: "23", label: "Retirado fin de año" },
                    { value: "24", label: "Retirado - Otros" }
                  ],
                  isMulti: false
                },
                renderIf: (ctx) => ctx.state.otherPromote
              },
              {
                col: 6,
                name: "superSectionId",
                rules: "required",
                value: null,
                type: "select",
                label: `${M}promoteToGrade`,
                opts: {
                  style: 'float-label',
                  path: "/admSuperSection/get?pick=true"
                },
                renderIf: (ctx) => !ctx.state.otherPromote
              },
              {
                col: 6,
                  name: "sectionId",
                  rules: "required",
                  value: "",
                  type: "select",
                  label: `${M}promoteToSection`,
                  opts: {
                    style: 'float-label',
                    path: () => { return "/admSection/get?pick=true&parentId=" + context.state.formFlags.superSectionId }
                  },
                  renderIf: (ctx) => {
                    if (ctx.state.otherPromote) return false;

                    context.state.formFlags.superSectionId = ctx.state.superSectionId;
                    return ctx.state.superSectionId }
              },
              {
                col: 12,
                name: "l1",
                value: (L) => L[`${M}msgBeforePromoting`],
                type: "label"
              },
            ],
            buttons: [
              {
                label: `${M}promoteStudents`,
                col: 12,
                isMain: true,
                onClick: (ctx) => { ctx.btnAction('save') }
              }
            ],
            onSuccess: (r) => { },
            onError: (e) => { }
          }
        }
      ],
      forms: [
        {
          name: 'main.setting',
          getUrl: 'admSuperSection/config',
          postUrl: 'admSuperSection/config',
          fields: [
            {
              col: 4,
              name: "hide",
              value: false,
              type: "switch",
              label: `${M}hideSectionsInApp`,
              rules: 'required',
              opts: {
                style: 'float-label'
              }
            },
            {
              col: 4,
              name: "syncToAcadYear",
              value: false,
              type: "select",
              label: "Aplicar secciones al año",
              rules: 'required',
              opts: {
                style: 'float-label',
                path: () => { return "admActivity/get/?type=ayr"}
              }
            },
          ],
          buttons: [
            {
              name: "",
              label: "main.apply",
              isMain: true,
              onClick: (ctx) => { ctx.btnAction('save') }
            }
          ],
          onSuccess: (r) => { },
          onError: (e) => { }
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.owner = { value: r.data.owner, label: r.data.ownerName }
          r.data.superowner = { value: r.data.superowner, label: r.data.superownerName }
        }
        return r
      },
      fields: [
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: `${M}gradeName`,
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "owner",
          value: "",
          type: "select",
          label: `${M}gradeAdvisor`,
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 6,
          name: "superowner",
          value: "",
          type: "select",
          label:  `${M}levelCoordinator`,
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 12,
          name: "groupBy",
          value: "",
          type: "text",
          label: `${M}groupedBy`,
          rules: 'max:20',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "btn1",
          value: null,
          type: "button",
          label: `${M}subLevels`,
          opts: {
            style: 'float-label'
          },
          onClick: (ctx) => {
            ctx.toogleSubGrid(0)
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
        },    
      ],
      subGrids: [
        {
          name: (ctx) => { return 'Secciones: ' + ctx.state.name },
          module: 'admSection',
          filterBy: () => { return { parentId: context.state.idItemSelected } }
        }
      ] 
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.desc",
        accessor: "desc"
      },
      {
        Header: "main.students",
        accessor: "count"
      },
      {
        Header: `${M}groupedBy`,
        accessor: "groupBy"
      }
    ]
  }
}